module.exports = __webpack_public_path__ + "static/media/graph.5bc530e4.svg";